module.exports = __webpack_public_path__ + "static/img/jigou-hainan-bottom.83447ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-hainan-bottom.png
// module id = GRlu
// module chunks = 2